import { SettingsParamType, createSettingsParams } from '@wix/tpa-settings';
import { MenusDisplayOptions } from './consts';
import type { LocationId } from 'root/types/locations';

export type IMenusSettingsParams = {
  menusDisplayOption: SettingsParamType.String;
  menusDisplayOrder?: SettingsParamType.String;
  locationDisplayOrder?: SettingsParamType.Object;
};

export type MenuOrder = { id: string; checked: boolean };
export type LocationOrder = LocationId[];

// Which menus to show and in what order is content selection, not a responsive
// layout concern. By default tpa-settings scopes every param per breakpoint, so
// the mobile panel would write its own value and stop following desktop. Forcing
// the key to be breakpoint-agnostic makes these params global: desktop and mobile
// always read and write the same stored value.
const globalKey = (key: string) => key;

export const MenusSettingsParams = createSettingsParams<IMenusSettingsParams>({
  menusDisplayOrder: {
    type: SettingsParamType.String,
    getDefaultValue: () => undefined,
    dangerousKeyTransformationOverride: globalKey,
  },
  menusDisplayOption: {
    type: SettingsParamType.String,
    getDefaultValue: () => MenusDisplayOptions.All,
    dangerousKeyTransformationOverride: globalKey,
  },
  locationDisplayOrder: {
    type: SettingsParamType.Object,
    getDefaultValue: () => undefined,
    dangerousKeyTransformationOverride: globalKey,
  },
});
